import React, { useState, useEffect, useRef, useContext } from "react";
import Card from "react-bootstrap/Card";
import Nav from "react-bootstrap/Nav";
import { Table, CardBody, CardHeader, Form } from "react-bootstrap";

import * as functions from "./overzichtFunctions";
import { getIconFromName, getOutputsFromName } from "./sharedFunctions";
import {
  RenderKastTree,
  dbItem,
  kastItem,
  mods2,
  modsArray2,
  modsForOfferteArray,
  modsForOfferte,
  kastOpbouw,
} from "./../../Shared/sharedInterfaces";
import { getTranslations } from "../../Shared/translations";
import { useSettings } from "../../Navbar/settingsContext";
import * as kastFunctions from "./kastopbouw";

import "./overzicht.css";

//import * as interfaces from "../../Shared/sharedInterfaces";
import { Box, ThemeProvider, createTheme } from "@mui/material";
import { TreeView } from "@mui/x-tree-view/TreeView";
//import TreeView from "@mui/lab/TreeView";
import * as myTreeIcons from "../../images/icons/treeicons";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
//import TreeItem from "@mui/lab/TreeItem";
import DynamicTreeViewc from "./kast/kastcomp";
import { InnerMapValue2 } from "./calculateFunctions";

import InfoScreen from "./info";

interface ControllerData {
  label: string;
  values: Map<string, number>;
}

interface MyProps {
  db: dbItem[]; // used by calc kast en info
  indienst: boolean;
  onOfferteChange: (
    data: modsForOfferteArray[],
    noSaItems: modsForOfferteArray[],
  ) => void;
  onInDienstChanged: (checked: boolean) => void;
  addKastToParentDb: () => void;
  addCtdToParentDb: () => void;
  setCtdToParent: (id: string) => void;
  setKastToParent: (id: string) => void;
  ctdId: Number;
  kastId: Number;
}

const CustomFontTheme = createTheme({
  typography: {
    fontSize: 11,
  },
});

//const Overzicht = (props: any) => {
const Overzicht = ({
  db,
  indienst,
  onOfferteChange,
  onInDienstChanged,
  addKastToParentDb,
  addCtdToParentDb,
  setKastToParent,
  setCtdToParent,
  ctdId,
  kastId
}: MyProps) => {
  console.log("🔁 Overzicht rendered");
  const t = getTranslations();
  
const {userSettings } = useSettings();
const rel04_08:boolean = userSettings?.onlysa ?? false;
const pakketten:boolean = userSettings?.pakket ?? false;


  const [dbForKast, setDbForKast] = useState<kastItem[] | []>([]);
  /*
  const [moduleCountsForKast, setMModuleCountsForKast] = useState<
    kastOpbouw[] | []
  >([]);
*/
  const [moduleCountsForKast2, setMModuleCountsForKast2] = useState<
  Map<string, Map<string, Map<string, InnerMapValue2>>>
>(new Map());

  const [selectedView, setSelectedView] = useState<ViewType | "">("");
  const [, setCalculating] = useState<boolean>(false);
  const [calcKast, setCalcKast] = useState<RenderKastTree | null>(null);
  const [indienstState, setIndienst] = useState<boolean>(indienst);

  const [fullOfferteItemsArray, setFullOfferteItemsArray] =
    useState<modsArray2>({ mods: [] });

  const [controllerMap, setControllerMap] =
    useState<Map<number,ControllerData>>();

    const raw = sessionStorage.getItem("maxadres");
const maxAdresses = raw ? Number(raw) : 388;

  const prevView = useRef<String>("offerte");

  type ViewType = "kast" | "offerte" | "sa-offerte" | "info";

  useEffect(() => {
    if (selectedView === "") {
      const key = prevView.current as ViewType;
      setSelectedView(key);
      //debugger
    }
  }, [selectedView]);

  // Show Kast, Offerte, ... on menu click
  const handleSelect = (eventKey: any) => {
    const key = `${eventKey}` as ViewType;
    if (["kast", "offerte", "sa-offerte", "info"].includes(key)) {
      setSelectedView(key);
    }
  };

  const handleIndienstCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    setIndienst(checked);
    onInDienstChanged(checked);
  };

  // Render function for tree recursively
  const renderTree = (nodes: RenderKastTree) => (
    <TreeItem
      key={nodes.id}
      nodeId={nodes.id}
      label={nodes.name}
      icon={nodes.icon}
    >
      {Array.isArray(nodes.children)
        ? nodes.children.map((node) => renderTree(node))
        : null}
    </TreeItem>
  );

  useEffect(() => {
    // Update fullOfferteItemsArray only when db or rel04/08 changes
    CalculateFullModulesForOfferte();
    if (selectedView === "kast") {
      calculateKast();
    }
  }, [db, selectedView, userSettings]);

  const CalculateFullModulesForOfferte = () => {

    const { combinedModules, calctd} = functions.calculate(false, rel04_08, true, db, maxAdresses);
    setFullOfferteItemsArray(combinedModules);
    setControllerMap(calctd)
  };

  const convertModsArray2ToModsForOfferteArray = (
    input: modsArray2[],
  ): modsForOfferteArray[] => {
    return input.map((modsGroup): modsForOfferteArray => {
      const transformedMods = modsGroup.mods.map(
        ({ modId, aantal }): modsForOfferte => ({
          modId,
          aantal,
        }),
      );
      return { mods: transformedMods };
    });
  };

  const calculatePackets = (
    offerteItems: mods2[],
    //full: boolean
  ): [mods2[]] => {
    let itemToRemove = 0;

    offerteItems.forEach((item) => {
      if (item.pakket && item.pakket !== 0 && pakketten === true) {
        const modPakket = functions.GetModById(item.pakket);

        const aantalPakketten = Math.floor(item.aantal / modPakket.outputs);
        const overschot = item.aantal - aantalPakketten * modPakket.outputs;

        if (aantalPakketten > 0) {
          const pakket: mods2 = {
            module: modPakket.name,
            aantal: aantalPakketten,
            prijs: modPakket.prijs,
            vrij: 0,
            modType: modPakket.type,
            modId: modPakket.id,
            sa: modPakket.sa,
            pakket: 0
          };

          offerteItems.push(pakket);
          item.aantal = overschot;

          if (overschot === 0) {
            itemToRemove = item.modId;
            pakket.vrij = item.vrij;
          }
        }
      }
    });

    // Remove modules from array if we only need packets
    const offerteItemsIncPackets = offerteItems.filter(
      (item) => item.modId !== itemToRemove,
    );

    return [offerteItemsIncPackets];
  };

  const createDataForServer = (
    offerteItemsFull: mods2[],
    offerteItemsSA: mods2[],
  ) => {
    const offerteItemsForOfferte: modsArray2 = {
      mods: offerteItemsFull,
    };

    const noSaOfferteItemsArray: modsArray2 = { mods: offerteItemsSA };

    // We only need modId en aantal here, so convert from modsArray2 to modsForOfferteArray
    // This way we have less data to send to the server
    const offerteItemsForOfferteSimpl: modsForOfferteArray[] =
      convertModsArray2ToModsForOfferteArray([offerteItemsForOfferte]);
    const noSaOfferteItemsArraySimpl: modsForOfferteArray[] =
      convertModsArray2ToModsForOfferteArray([noSaOfferteItemsArray]);

    // Send items for offertes to Navbar in case they have to be exported
    onOfferteChange(offerteItemsForOfferteSimpl, noSaOfferteItemsArraySimpl);
  };

  const getNextKastId = (items: dbItem[]) => {
    const kastIds = items.map((item) => item.outputOptions.kastId);

    return {
      nextKastId: kastIds.length > 0 ? Math.max(...kastIds) + 1 : 1,
    };
  };

  const getNextCtdId = (items: dbItem[]) => {
    const ctdIds = items.map((item) => item.outputOptions.ctdId);

    return {
      nextCtdId: ctdIds.length > 0 ? Math.max(...ctdIds) + 1 : 1,
    };
  };

  const dbItemToKastItem = (
    db: dbItem[],
    type: "controller" | "kast" | "module",
  ) => {
    const modulesForKastOpbouw: kastOpbouw[] = [];

    db.forEach((dbItem) => {
      if (dbItem.type === type) {
        let id: number = 0;
        if (type == "kast") {
          id = dbItem.outputOptions.kastId;
        } else if (type == "controller") {
          id = dbItem.outputOptions.ctdId;
        }

        const kastItem: kastOpbouw = {
          module: dbItem.label,
          type: type,
          id: id,
        };
        modulesForKastOpbouw.push(kastItem);
      }
    });
    return modulesForKastOpbouw;
  };



  const createModulesForKastOpbouw = (offerteItemsArray: mods2[]) => {
    const modulesForKastOpbouw: kastOpbouw[] = [];

    offerteItemsArray.forEach((offerteItem) => {
      for (let i = 0; i < offerteItem.aantal; i++) {
        if (offerteItem.modType !== "CTD") {
          const kastItem: kastOpbouw = {
            module: offerteItem.module,
            type: "module",
            nrofoutputs: getOutputsFromName(offerteItem.module),
            typeIcon: getIconFromName(offerteItem.module),
            parent: 0
          };
          modulesForKastOpbouw.push(kastItem);
        } else {
          const kastItem: kastOpbouw = {
            module: offerteItem.module,
            type: "controller",
            nrofoutputs: getOutputsFromName(offerteItem.module),
            typeIcon: getIconFromName(offerteItem.module),
            parent: 0,
            id: 1
          };
          modulesForKastOpbouw.push(kastItem);
        }
      }
    });

    return modulesForKastOpbouw;
  };

  const addKastToOverzicht = () => {
    // push kast to parent (opbouw)
    addKastToParentDb();
  };

  const addCtdToOverzicht = () => {
    // push kast to parent (opbouw)
    addCtdToParentDb();
  };

  const setCtdToOverzicht = (id: string) => {
    // push ctd to parent (opbouw)
   setCtdToParent(id);
   //setCtdToOverzicht(id);
  };

    const setKastToOverzicht = (id: string) => {
    // push ctd to parent (opbouw)
   setKastToParent(id);
   //setKastToOverzicht(id);
  };



  const createDataForFulleOfferte = (): [mods2[], number, number] => {
    let totIndienst = 0;
    let totaal = 0;
    //Bereken pakketten

    const [offerteItemsIncPackets] = calculatePackets(
      fullOfferteItemsArray.mods,
    );

    // Bereken de totaal en indienst prijs
    offerteItemsIncPackets.forEach((item) => {
      // We only calculate indienst for modules with a bus connector
      const modInfo = functions.GetModById(item.modId);
      if (modInfo.busConsumption > -1) {
        totIndienst += item.prijs * item.aantal;
        totIndienst = +totIndienst.toFixed(2);
      }

      totaal += item.prijs * item.aantal;
      totaal = +totaal.toFixed(2);
    });

    // Create the objects to send to server
    const noSaOfferteItemsArray: modsArray2 = { mods: [] }; // Empty array here because we only calculated for Full

    createDataForServer(offerteItemsIncPackets, noSaOfferteItemsArray.mods);

    return [offerteItemsIncPackets, totaal, totIndienst];
  };

    // Convert dbItem[] to kastItem[]
  const createOutputsForKastopbouw = (db: dbItem[]) => {
    const convert = (data: dbItem[]): kastItem[] =>
      data
        .filter((item) => item.type !== "ctd") // don't add ctds
        .map(({ label, type, typeIcon, outputOptions }) => ({
          label,
          type,
          typeIcon,
          outputOptions: {
            ...outputOptions,
            //ctdId: 1, // example transformation
            //GroupType: outputOptions.GroupType,
          },
        }));
    return convert(db);
  };

  const calculateKast = () => {
    createDataForFulleOfferte();

    //dbForKast is a variable for DynamicTreeViewc
    // we convert db from dbItem[] to kastItem[]
    let kastDb: kastItem[] = createOutputsForKastopbouw(db);
    setDbForKast(kastDb);
    // Here we have to re-calculate offerteItemsArray to avoid sets
    const { modulesMap2} = functions.calculate(false, rel04_08, true, db, maxAdresses);

    setMModuleCountsForKast2(modulesMap2)
  };

  const RenderOfferte = () => {
    console.log("🔁 offerte rendered");

    let aantInd = "";

    const [offerteItemsIncPackets, totaal, totIndienst] =
      createDataForFulleOfferte();

    const indienstMod = functions.GetModById(180);
    const indienstPrijs = indienstMod.prijs;

    aantInd = (+(totIndienst / 1000) * indienstPrijs).toFixed(2);

    return (
      <>
        <Table striped bordered hover style={{ fontSize: 14 }}>
          <thead>
            <tr>
              <th>{t.module}</th>
              <th>{t.aantal}</th>
              <th>{t.prijs}</th>
              <th>{t.totaal}</th>
              <th>{t.vrije}</th>
            </tr>
          </thead>
          <tbody>
            {offerteItemsIncPackets.map((item) => (
              <tr key={item.module}>
                <td>{item.module}</td>
                <td>{item.aantal}</td>
                <td>{item.prijs}</td>
                <td>{item.prijs * item.aantal}</td>
                <td>{item.vrij}</td>
              </tr>
            ))}
          </tbody>
        </Table>

        <Form.Check
          type="checkbox"
          id="check-api-checkbox4"
          className="formCheck_overzicht"
        >
          <Form.Check.Input
            type="checkbox"
            checked={indienstState}
            name="indienst"
            onChange={handleIndienstCheck}
          />
          <Form.Check.Label className="formLabel_overzicht">
            {t.voegIndienstToe}
          </Form.Check.Label>
        </Form.Check>

        <div className="totals">
          {t.totaalprijs}: €{totaal}
          <br />
          {indienstState && <>{t.indienst}: €{aantInd}</>}
        </div>
      </>
    );
  };

  const RenderSaOfferte = () => {
    console.log("🔁 saOff rendered");
    let totaal = 0;

    //Bereken pakketten
    const [offerteItemsIncPackets] = calculatePackets(
      fullOfferteItemsArray.mods,
    );

    // Bereken de totaalprijs
    offerteItemsIncPackets.forEach((item) => {
      if (item.sa === 1) {
        totaal += item.prijs * item.aantal;
        totaal = +totaal.toFixed(2);
      }
    });

    // Create the objects to send to server
    const NoSaOfferteItemsForOfferte: modsArray2 = { mods: [] };
    const SaOfferteItemsForOfferte: modsArray2 = { mods: [] };

    // Split SA mods and No SA mods
    offerteItemsIncPackets.forEach((item) => {
      if (item.sa === 0 || !item.sa) {
        NoSaOfferteItemsForOfferte.mods.push(item);
      } else {
        SaOfferteItemsForOfferte.mods.push(item);
      }
    });

    createDataForServer(
      SaOfferteItemsForOfferte.mods,
      NoSaOfferteItemsForOfferte.mods,
    );

    return (
      <>
        <Table striped bordered hover style={{ fontSize: 14 }}>
          <thead>
            <tr>
              <th>{t.module}</th>
              <th>{t.aantal}</th>
              <th>{t.prijs}</th>
              <th>{t.totaal}</th>
              <th>{t.vrije}</th>
            </tr>
          </thead>
          <tbody>
            {SaOfferteItemsForOfferte.mods.map(
              (offerteItem: mods2) => (
                // offerteItem.sa === 1 ? (
                <tr key={offerteItem.module}>
                  <td>{offerteItem.module}</td>
                  <td>{offerteItem.aantal}</td>
                  <td>{offerteItem.prijs}</td>
                  <td>{offerteItem.prijs * offerteItem.aantal}</td>
                  <td>{offerteItem.vrij}</td>
                </tr>
              ),
              // ) : null
            )}
          </tbody>
        </Table>
        <div className="totals">{t.totaalprijs}: €{totaal}</div>
        <br />
        {t.nietInSa}
        <Table striped bordered hover style={{ fontSize: 14 }}>
          <thead>
            <tr>
              <th>{t.module}</th>
              <th>{t.aantal}</th>
              <th>{t.prijs}</th>
              <th>{t.totaal}</th>
              <th>{t.vrije}</th>
            </tr>
          </thead>
          <tbody>
            {NoSaOfferteItemsForOfferte.mods.map(
              (offerteItem: mods2) => (
                //offerteItem.sa !== 1 ? (
                <tr key={offerteItem.module}>
                  <td>{offerteItem.module}</td>
                  <td>{offerteItem.aantal}</td>
                  <td>{offerteItem.prijs}</td>
                  <td>{offerteItem.prijs * offerteItem.aantal}</td>
                  <td>{offerteItem.vrij}</td>
                </tr>
              ),
              // ) : null
            )}
          </tbody>
        </Table>
      </>
    );
  };

  const RenderInfo = () => {
    /*
    let totadresses = 0;
    console.log("🔁 Info rendered");
    // Calculate full oferte in case we want to export it
    createDataForFulleOfferte();

    // Calculate adresses by ctd
    db.forEach((item: any) => {
      const type = item.type;
      const parameters = functions.getModuleParametersByType(type);
      const adresses = parameters.adresses;

      let dmxT = "";
      if ("outputOptions" in item) {
        const outputOptions = item.outputOptions;
        dmxT = outputOptions.DmxType;
      }

      let dmxA = 0;

      if (dmxT) {
        switch (dmxT) {
          case "1":
            dmxA = 1;
            break;
          case "6":
          case "8":
          case "4":
            dmxA = 10;
            break;
        }
        totadresses += dmxA;
      } else {
        totadresses += adresses;
      }
    });

    // Calculate bus consumption and adresses from calcKast
    let ctdBusCons = 0;
    let ctdadresses = 0;
    if (calcKast?.children) {
      calcKast.children?.forEach((ctd) => {
        let ctdBusConsLocal = 0;
        let ctdadressesLocal = 0;

        ctd.children?.forEach((dindec) => {
          dindec.children?.forEach((module) => {
            const modT = module.name;
            const outpOnMod: number = module.children?.length || 1;
            const modparams = functions.getModuleParameters(modT);
            ctdadressesLocal += modparams.adresses * outpOnMod;
            ctdBusConsLocal += modparams.busConsumption;
          });
        });

        ctdBusCons += ctdBusConsLocal;
        ctdadresses += ctdadressesLocal;
      });
    }
      */
//<InfoScreen db={db} kasten={moduleCountsForKast2}></InfoScreen>
    return (
      <>
      
      <InfoScreen controllerMap={controllerMap}></InfoScreen>
      </>
      /*
      <div>
        Type uitvoering: {sessionStorage.getItem("uitvoering")} <br />
        Aantal gebruikte adressen: {totadresses} <br />
        Totaal busverbruik: {ctdBusCons} <br />
      </div>
      */
    );
  };

  return (
    <Card id="card_overzicht" style={{ height: "95vh" }}>
      <CardHeader>
        <Nav onSelect={handleSelect} activeKey={selectedView}>
          <Nav.Item>
            <Nav.Link eventKey="kast" className="building-nav">
              {t.kast}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="offerte" className="building-nav">
              {t.offerte}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="sa-offerte" className="building-nav">
              {t.saOfferte}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="info" className="building-nav">
              {t.info}
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </CardHeader>

      <CardBody style={{ overflow: "auto" }}>
        {selectedView === "kast" && (
          <DynamicTreeViewc
            db2={dbForKast}
            //modulesList={moduleCountsForKast}
            modulesList2={moduleCountsForKast2}
            addKastToOverzicht={addKastToOverzicht}
            addCtdToOverzicht={addCtdToOverzicht}
            setCtd={setCtdToOverzicht}
            setKast={setKastToOverzicht}
            ctdId={ctdId}
            kastId={kastId}
            controllerMap={controllerMap}
          />
        )}
        {selectedView === "offerte" && <RenderOfferte />}
        {selectedView === "sa-offerte" && <RenderSaOfferte />}
        {selectedView === "info" && <RenderInfo />}
      </CardBody>
    </Card>
  );
};

export default Overzicht;
